import {
  ArrowDropDown as ArrowDropDownIcon,
  ArrowDropUp as ArrowDropUpIcon,
} from '@mui/icons-material';

import { useTheme } from '@mui/material';

const IconToggle = ({ open, isPrimaryBorder, hover, size = 28 }) => {
  const theme = useTheme();
  const Icon = open ? ArrowDropUpIcon : ArrowDropDownIcon;

  const colorDefault = isPrimaryBorder ? theme.primary : theme.tertiary;
  const colorHover = isPrimaryBorder ? theme.tertiary : theme.primary;

  return (
    <Icon
      sx={{
        fontSize: size,
        width: size,
        height: size,
        flexShrink: 0,
        display: 'inline-block',
        lineHeight: 1,
        color: hover ? colorHover : colorDefault,
        transition: 'color 0.2s',
      }}
    />
  );
};

export default IconToggle;
